import masterCard from '../../public/assets/wave-grocery/masterCard.png';
import visa from '../../public/assets/wave-grocery/visa.png';
import maestro from '../../public/assets/wave-grocery/maestro.png';
import amex from '../../public/assets/wave-grocery/amex.png';
import discover from '../../public/assets/wave-grocery/Discover.png';
import dinners from '../../public/assets/wave-grocery/Dinners.png';

export function getCardList(cards, onDeleteClick) {
  const finalCards = [];
  cards.map((card, index) => {
    const newCard = {
      subtitle: `xxxx xxxx xxxx ${card.maskedNumber}`,
      title: card.cardScheme,
      isAddNew: false,
      isMainAddress: false,
      onDelete: () => {
        onDeleteClick(card._id);
      },
      type: 'card',
      image: getCardImage(card.cardScheme),
    };
    finalCards.push(newCard);
  });
  return finalCards;
}

export function getCardImage(cardScheme) {
  if (cardScheme.toUpperCase() === 'VISA') {
    return visa.src;
  } else if (cardScheme.toUpperCase() === 'MASTERCARD') {
    return masterCard.src;
  } else if (cardScheme.toUpperCase() === 'MAESTRO') {
    return maestro.src;
  } else if (cardScheme.toUpperCase() === 'AMEX') {
    return amex.src;
  }
 else if (cardScheme.toUpperCase() === 'DISCOVER') {
  return discover.src;
} else if (cardScheme.toUpperCase() === 'DINNERS') {
  return dinners.src;
}
}
